import { RootState } from '../store/configureStore';

export const getFieldTypes = (state: RootState) => state?.fieldType?.fieldTypes;

export const isFetchingFieldTypes = (state: RootState) =>
  state?.fieldType?.isFetchingFieldTypes

export const fetchingFieldTypesFailed = (state: RootState) =>
  state?.fieldType?.fetchingFieldTypesFailed;
